/* eslint-disable no-lone-blocks */
// export NODE_OPTIONS="--max-old-space-size=8192"
import React from "react";
import { connect } from "react-redux";
import $ from "jquery";
import {
  displayChartManager,
  pitStatusSteppedCharts,
  pitStatusBubbleChart,
  realtimeChart,
  groupLineChart,
} from "util/chartManager";
import Button from "material-ui/Button";
import moment from "moment";
import IconButton from "material-ui/IconButton";
import Tooltip from 'material-ui/Tooltip';
import { getFormattedDate, getTimeFromTimestamp } from "util/util";
import {
  Dropdown,
  Table,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardBody,
  CardText,
} from "reactstrap";
import {
  getLastNRecordsFromAllSensors,
  getPitStatus,
  getPitWarningLevel,
  requestTechOnSiteData,
  getNumberOfPitStatus,
  getAllConfiguration,
  getPitDepth,
  getLocation,
  getIndividualNodeVitals,
} from "util/aws-manager";
import TimeAgo from "react-timeago";
import SymbioticMarkerClusterer from "./../devices/Components/SymbioticMarkerClusterer";
import * as CONST from "util/app-constants";

const filter = [
  {
    item: "Latest 10 Records",
  },
  {
    item: "1 Day",
  },
  {
    item: "7 Days",
  },
  {
    item: "14 Days",
  },
  {
    item: "28 Days",
  },
];

const tempTypeSensor = [
  // {
  //   item: "All Sensors",
  //   type: "All",
  // },
  {
    item: "Sensor 1",
    type: "temperature1",
  },
  {
    item: "Sensor 2",
    type: "temperature2",
  },
  {
    item: "Sensor 3",
    type: "temperature3",
  },
];

const powerTypeSensor = [
  {
    item: "Sensor 1",
    type: "current1",
  },
  {
    item: "Sensor 2",
    type: "current2",
  },
];

class App extends React.Component {
  temperatureChart = {};
  waterLevelChart = {};
  batteryChargeChart = {};
  powerChart = {};
  pitStatusModalBubbleChart = {};
  securityPitStatusChart = {};
  securityTechOnSiteChart = {};

  temperatureChartModal = {};
  waterLevelChartModal = {};
  batteryChargeChartModal = {};
  securityPitStatusModal = {};
  securityTechOnSiteModal = {};

  temperatureId = "temperature";
  waterLevelId = "waterLevel";
  powerId = "powerId";
  batteryChargeId = "batteryCharge";
  securityPitStatusId = "securityPitStatus";
  securityTechOnSiteId = "securityTechOnSite";

  temperatureModalId = "temperature-modal";
  waterLevelModalId = "water-level-modal";
  batteryChargeModalId = "battery-charge-modal";
  securityPitStatusModalId = "securityPitStatusModalId";
  securityTechOnSiteModalId = "securityTechOnSiteModalId";

  latestT = "0º";
  latestP = "0 amp";
  latestSD = "0cm";
  latestBC = "0V";

  latestTM = "0º";
  latestSDM = "0cm";
  latestBCM = "0V";

  lastInteractionReceived = "Friday 8 December, 08:13 am";

  tenMinutesHistoryPolling;

  deviceChartsPollingSetInterval;

  UpdateTemperatureChartWithId = () => {
    this.temperatureChartWithId = {
      chartJSX: (
        <div
          data-toggle="modal"
          data-target="#temperatureModal"
          className="col-12 col-xl-7 col-lg-12 col-sm-12 col-xs-12"
        >
          <canvas id={this.temperatureId} />
        </div>
      ),
      id: 1457690402,
    };
  };

  UpdateWaterLevelChartWithId = () => {
    this.waterLevelChartWithId = {
      chartJSX: (
        <div
          data-toggle="modal"
          data-target="#waterLevelModal"
          className="col-12 col-xl-7 col-lg-12 col-sm-12 col-xs-12"
        >
          <canvas id={this.waterLevelId} />
        </div>
      ),
      id: 1457690403,
    };
  };

  selectTempToggle = () => {
    this.setState({
      temperaturetoggle: !this.state.temperaturetoggle,
    });
  };

  selectTempTypeToggle = () => {
    this.setState({
      tempSensorToggle: !this.state.tempSensorToggle,
    });
  };

  selectPowerTypeToggle = () => {
    this.setState({
      powerSensorToggle: !this.state.powerSensorToggle,
    });
  };

  selectWaterToggle = () => {
    this.setState({
      watertoggle: !this.state.watertoggle,
    });
  };

  selectPowerToggle = () => {
    this.setState({
      powerToggle: !this.state.powerToggle,
    });
  };

  selectPitStatusToggle = () => {
    this.setState({
      pitStatustoggle: !this.state.pitStatustoggle,
    });
  };

  findAverage = (data) => {
    const sum = data.reduce((a, b) => {
      return parseFloat(a) + parseFloat(b);
    }, 0);
    const average = sum / data.length;
    if (Number.isNaN(average)) {
      return 0;
    }
    return average;
  };

  calculateOpenPit = (data) => {
    const count = data.filter((item) => {
      return item === "Open" || item === "open";
    }).length;
    return count;
  };

  findMaximumValue = (data) => {
    const maxValue = Math.max(...data);
    if (Number.isFinite(maxValue)) {
      return maxValue.toFixed(2);
    }
    return 0;
  };

  findMinimumValue = (data) => {
    const minValue = Math.min(...data);
    if (Number.isFinite(minValue)) {
      return minValue.toFixed(2);
    }
    return 0;
  };

  findIncreasePercentage = (data) => {
    const percentageIncrease = ((data[data.length - 1] - data[0]) / 2) * 100;
    if (Number.isNaN(percentageIncrease)) {
      return `${0}%`;
    }
    return `${percentageIncrease.toFixed(2)}%`;
  };

  renderTempFilter = () => {
    return (
      <Card className="shadow border-1 recordOuterContainer">
        <CardBody className="recordContainer">
          <CardText className="row">
            <div className="col-12 col-xl-12 col-lg-12 col-sm-12 col-xs-12 px-0">
              <Dropdown
                isOpen={this.state.tempSensorToggle}
                toggle={this.selectTempTypeToggle}
              >
                <DropdownToggle color="Secondary" caret>
                  {this.state.tempSensorType}
                </DropdownToggle>
                <DropdownMenu>
                  {tempTypeSensor.map((data) => {
                    return (
                      <DropdownItem onClick={this.selectTempSensorType}>
                        {data.item}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </Dropdown>
            </div>
            <div className="col-12 col-xl-12 col-lg-12 col-sm-12 col-xs-12 px-0">
              <Dropdown
                isOpen={this.state.temperaturetoggle}
                toggle={this.selectTempToggle}
              >
                <DropdownToggle color="Secondary" caret>
                  {this.state.temperatureFilter}
                </DropdownToggle>
                <DropdownMenu>
                  {filter.map((data) => {
                    return (
                      <DropdownItem onClick={this.selectTemperatureFilter}>
                        {data.item}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </Dropdown>
            </div>
          </CardText>
          <CardText>
            Average
            <h2>{this.findAverage(this.state.temperatureData).toFixed(2)}º</h2>
          </CardText>
          <CardText>
            Percentage Change
            <h2>{this.findIncreasePercentage(this.state.temperatureData)}</h2>
          </CardText>
          <CardText className="row">
            <div className="col-12 col-lg-6 col-sm-12 col-xs-12">
              <h3>
                Min
                <h3
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  {this.findMinimumValue(this.state.temperatureData)}º
                </h3>
              </h3>
            </div>
            <div className="col-12 col-lg-6 col-sm-12 col-xs-12">
              <h3>
                Max
                <h3
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  {this.findMaximumValue(this.state.temperatureData)}º
                </h3>
              </h3>
            </div>
          </CardText>
        </CardBody>
      </Card>
    );
  };

  renderPowerFilter = () => {
    return (
      <Card className="shadow border-1 recordOuterContainer">
        <CardBody className="recordContainer">
          <CardText className="row">
            <div className="col-12 col-lg-12 col-sm-12 col-xs-12 px-0">
              <Dropdown
                isOpen={this.state.powerSensorToggle}
                toggle={this.selectPowerTypeToggle}
              >
                <DropdownToggle color="Secondary" caret>
                  {this.state.powerSensorType}
                </DropdownToggle>
                <DropdownMenu>
                  {powerTypeSensor.map((data) => {
                    return (
                      <DropdownItem onClick={this.selectPowerSensorType}>
                        {data.item}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </Dropdown>
            </div>
            <div className="col-12 col-lg-12 col-sm-12 col-xs-12 px-0">
              <Dropdown
                isOpen={this.state.powerToggle}
                toggle={this.selectPowerToggle}
              >
                <DropdownToggle color="Secondary" caret>
                  {this.state.powerFilter}
                </DropdownToggle>
                <DropdownMenu>
                  {filter.map((data) => {
                    return (
                      <DropdownItem onClick={this.selectPowerFilter}>
                        {data.item}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </Dropdown>
            </div>
          </CardText>
          <CardText>
            Average
            <h2>{this.findAverage(this.state.powerData).toFixed(2)}</h2>
          </CardText>
          <CardText>
            Percentage Change
            <h2>{this.findIncreasePercentage(this.state.powerData)}</h2>
          </CardText>
          <CardText className="row">
            <div className="col-12 col-lg-6 col-sm-12 col-xs-12">
              <h3>
                Min
                <h3
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  {this.findMinimumValue(this.state.powerData)}
                </h3>
              </h3>
            </div>
            <div className="col-12 col-lg-6 col-sm-12 col-xs-12">
              <h3>
                Max
                <h3
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  {this.findMaximumValue(this.state.powerData)}
                </h3>
              </h3>
            </div>
          </CardText>
        </CardBody>
      </Card>
    );
  };

  renderWaterFilter = () => {
    return (
      <Card className="shadow border-1 recordOuterContainer">
        <CardBody className="recordContainer">
          <CardText>
            <Dropdown
              isOpen={this.state.watertoggle}
              toggle={this.selectWaterToggle}
            >
              <DropdownToggle color="Secondary" caret>
                {this.state.waterFilter}
              </DropdownToggle>
              <DropdownMenu>
                {filter.map((data) => {
                  return (
                    <DropdownItem onClick={this.selectWaterFilter}>
                      {data.item}
                    </DropdownItem>
                  );
                })}
              </DropdownMenu>
            </Dropdown>
          </CardText>
          <CardText>
            Average
            <h2>{this.findAverage(this.state.waterLevelData).toFixed(2)}cm</h2>
          </CardText>
          <CardText>
            Percentage Change
            <h2>{this.findIncreasePercentage(this.state.waterLevelData)}</h2>
          </CardText>
          <CardText className="row">
            <div className="col-12 col-lg-6 col-sm-12 col-xs-12">
              <h3>
                Min
                <h3
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  {this.findMinimumValue(this.state.waterLevelData)}cm
                </h3>
              </h3>
            </div>
            <div className="col-12 col-lg-6 col-sm-12 col-xs-12">
              <h3>
                Max
                <h3
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  {this.findMaximumValue(this.state.waterLevelData)}cm
                </h3>
              </h3>
            </div>
          </CardText>
        </CardBody>
      </Card>
    );
  };

  renderPitStatusFilter = () => {
    return (
      <Card className="shadow border-1 recordOuterContainer">
        <CardBody className="recordContainer">
          <CardText>
            <Dropdown
              isOpen={this.state.pitStatustoggle}
              toggle={this.selectPitStatusToggle}
            >
              <DropdownToggle color="Secondary" caret>
                {this.state.pitStatusFilter}
              </DropdownToggle>
              <DropdownMenu>
                {filter.map((data) => {
                  return (
                    <DropdownItem onClick={this.selectPitStatusFilter}>
                      {data.item}
                    </DropdownItem>
                  );
                })}
              </DropdownMenu>
            </Dropdown>
          </CardText>
          <CardText>
            How many times open
            <h2>{this.calculateOpenPit(this.state.pitStatus)}</h2>
          </CardText>
        </CardBody>
      </Card>
    );
  };

  selectTemperatureFilter = (event) => {
    this.setState(
      {
        temperatureFilter: event.target.innerText,
      },
      () => {
        this.getChartData();
      }
    );
  };

  selectTempSensorType = (event) => {
    this.setState(
      {
        tempSensorType: event.target.innerText,
      },
      () => {
        this.getChartData();
      }
    );
  };

  selectPowerSensorType = (event) => {
    this.setState(
      {
        powerSensorType: event.target.innerText,
      },
      () => {
        this.getChartData();
      }
    );
  };

  selectPowerFilter = (event) => {
    this.setState(
      {
        powerFilter: event.target.innerText,
      },
      () => {
        this.getChartData();
      }
    );
  };

  selectWaterFilter = (event) => {
    this.setState(
      {
        waterFilter: event.target.innerText,
      },
      () => {
        this.getChartData();
      }
    );
  };

  selectPitStatusFilter = (event) => {
    this.setState(
      {
        pitStatusFilter: event.target.innerText,
      },
      () => {
        this.getChartData();
      }
    );
  };

  renderGraph = () => {
    return (
      <div className="col-12 col-xl-6 col-lg-6 col-sm-6 col-xs-12">
        <SymbioticMarkerClusterer
          navigate={()=>{}}
          markerData={[this.state.deviceLocation]}
          onBoundsChanged={(bounds) => { }}
        />
      </div>)
  }

  render = () => {
    const batteryVoltage = this.state.nodeVitals.length > 0 && this.state.nodeVitals[0] && this.state.nodeVitals[0].values && this.state.nodeVitals[0].values.batteryVoltage;
    const signalStrength = this.state.nodeVitals.length > 0 && this.state.nodeVitals[0] && this.state.nodeVitals[0].values && this.state.nodeVitals[0].values.signalStrength;
    const { deviceId } = this.props;
    const isRevDevices = deviceId.includes('rev');
    const isEptDevices = deviceId.includes('ept');
    const otherDevices = !deviceId.includes('ept') && !deviceId.includes('rev');
    return (
      <div className="row heartbeat-page">
        <div className="col-12">
          <div className="row page-heading d-sm-flex justify-content-sm-between align-items-sm-center">
            <div className="col-12 col-lg-6 col-sm-12 col-xs-12">
              {/* <h1 className="heartbeat-main-heading mb-0">HEARTBEAT</h1> */}
              <div className="d-flex align-items-end mb-2">
                Device ID: {this.state.deviceId}
                {this.getdeviceOnline()}
                <Tooltip
                  title={`Signal Strength: ${signalStrength ? signalStrength : 'Not Available'}`}
                  placement={'bottom-end'}
                >
                  {this.showSignalLevel(signalStrength)}
                </Tooltip>
                <Tooltip
                  title={`Battery Level: ${batteryVoltage ? batteryVoltage : 'Not Available'}`}
                  placement={'bottom-end'}
                >
                  {this.showBatteryLevel(batteryVoltage)}
                </Tooltip>
              </div>
              <div>
                Last Updated: {this.getLastUpdatedTime()}
              </div>
              <div className="mt-2">
                {this.getNextUpdatedTime()}
              </div>
            </div>
            <div>
              {/* <TimeAgo date={new Date(this.getUpdatedTimeAgo() * 1000)} /> */}
              <i
                className="fa fa-map-marker mt-1 pr-2"
                style={{
                  fontSize: 18,
                  color: 'red',
                }}
                aria-hidden="true"
              />
              {this.state.deviceLocation.streetAddress}
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="col-12">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
              <div className="row">
                {((!isRevDevices && isEptDevices) || otherDevices) &&
                  <div className="col-12 col-sm-6 col-lg-6">
                    <div className="jr-card mainHeight">
                      <div>
                        <div
                          className="jr-card-header w-100 clickable"
                          role="button"
                          id={`header-${this.temperatureId}`}
                          data-toggle="collapse"
                          data-parent="#accordion"
                          href="#collapseFour"
                          aria-expanded="true"
                          aria-controls="collapseFour"
                        >
                          <h2 className="card-heading d-inline-block">
                            Temperature{" "}
                          </h2>
                          <h3 className="mb-0 d-inline-block float-right popupHeading">
                            {" "}
                            {this.state.latestTemperature}{" "}
                          </h3>
                        </div>
                        <div
                          id="collapseFour"
                          className="collapse show"
                          role="tabpanel"
                          aria-labelledby={`header-${this.temperatureId}`}
                        >
                          <div className="jr-card-body row">
                            {this.state.chartsToShow[0]}
                            <div className="col-12  col-xl-5 col-lg-12 col-sm-12 col-xs-12 justify-content-center d-flex">
                              {this.renderTempFilter()}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>}
                {!isRevDevices && this.renderGraph()}
                {((!isRevDevices && isEptDevices) || otherDevices) &&
                  <div className="col-12 col-sm-6 col-lg-6">
                    <div className="jr-card mainHeight">
                      <div>
                        <div
                          className="jr-card-header w-100 clickable"
                          role="button"
                          id={`header-${this.waterLevelId}`}
                          data-toggle="collapse"
                          data-parent="#accordion"
                          href="#collapseFive"
                          aria-expanded="true"
                          aria-controls="collapseFive"
                        >
                          <h2 className="card-heading d-inline-block">
                            {" "}
                            Water level in the pit{" "}
                          </h2>
                          <h3 className="mb-0 d-inline-block float-right popupHeading">
                            {" "}
                            {this.state.latestWaterLevel}{" "}
                          </h3>
                        </div>
                        <div
                          id="collapseFive"
                          className="collapse show"
                          role="tabpanel"
                          aria-labelledby={`header-${this.waterLevelId}`}
                        >
                          <div className="jr-card-body row">
                            {this.state.chartsToShow[1]}
                            <div className="col-12 col-xl-5 col-lg-12 col-sm-12 col-xs-12 justify-content-center  d-flex">
                              {this.renderWaterFilter()}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>}
                {((!isRevDevices && isEptDevices) || otherDevices) &&
                  <div className="col-12 col-sm-6 col-lg-6">
                    <div className="jr-card mainHeight">
                      <div>
                        <div
                          className="jr-card-header w-100 clickable"
                          role="button"
                          id={`header-${this.securityPitStatusId}`}
                          data-toggle="collapse"
                          data-parent="#accordion"
                          href="#collapseTwo"
                          aria-expanded="true"
                          aria-controls="collapseTwo"
                        >
                          <h1 className="card-heading d-inline-block">
                            Switch Status{" "}
                          </h1>
                          {this.state.latestPitStatus == "Open" ? (
                            <div className="d-inline-block float-right">
                              <img
                                className="battery-charge-img d-inline-block float-left"
                                src="../../../../assets/images/pitOpen.png"
                                alt="switch status"
                              />
                              <h2 className="mb-0 ml-2 d-inline-block float-right popupHeading">
                                {" "}
                                {this.state.latestPitStatus}{" "}
                              </h2>
                            </div>
                          ) : (
                              <div className="d-inline-block float-right">
                                <img
                                  className="battery-charge-img d-inline-block float-left"
                                  src="../../../../assets/images/pitClose.png"
                                  alt="switch status"
                                />
                                <h2 className="mb-0 ml-2 d-inline-block float-right popupHeading">
                                  {" "}
                                  {this.state.latestPitStatus}{" "}
                                </h2>
                              </div>
                            )}
                        </div>
                        <div
                          id="collapseTwo"
                          className="collapse show"
                          role="tabpanel"
                          aria-labelledby={`header-${this.securityPitStatusId}`}
                        >
                          <div className="jr-card-body row">
                            <div
                              data-toggle="modal"
                              data-target="#securityPitStatusModal"
                              className="col-12 col-xl-7 col-lg-12 col-sm-12 col-xs-12"
                            >
                              <canvas id="securityPitStatus" />
                            </div>
                            <div className="col-12 col-xl-5 col-lg-12 col-sm-12 col-xs-12 justify-content-center d-flex">
                              {this.renderPitStatusFilter()}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>}
                {((isRevDevices && !isEptDevices) || otherDevices) &&
                  <div className="col-12 col-xl-6 col-lg-6 col-sm-12 col-xs-12">
                    <div className="jr-card mainHeight">
                      <div>
                        <div
                          className="jr-card-header w-100 clickable"
                          role="button"
                          id={`header-${this.powerId}`}
                          data-toggle="collapse"
                          data-parent="#accordion"
                          href="#collapseFive"
                          aria-expanded="true"
                          aria-controls="collapseFive"
                        >
                          <h2 className="card-heading d-inline-block">
                            {" "}
                            Power{" "}
                          </h2>
                          <h3 className="mb-0 d-inline-block float-right popupHeading">
                            {" "}
                            {this.state.latestPower}{" "}
                          </h3>
                        </div>
                        <div
                          id="collapseFive"
                          className="collapse show"
                          role="tabpanel"
                          aria-labelledby={`header-${this.powerId}`}
                        >
                          <div className="jr-card-body row">
                            <div
                              data-toggle="modal"
                              data-target="#currentModal"
                              className="col-12 col-xl-7 col-lg-12 col-sm-12 col-xs-12"
                            >
                              <canvas id={this.powerId} />
                            </div>
                            <div className="col-12 col-xl-5 col-lg-12 col-sm-12 col-xs-12 justify-content-center  d-flex">
                              {this.renderPowerFilter()}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>}
                {((!isRevDevices && isEptDevices) || otherDevices) &&
                  <div className={isEptDevices ? "col-12 col-xl-12 col-lg-12 col-sm-12 col-xs-12" : "col-12 col-xl-6 col-lg-6 col-sm-12 col-xs-12"}>
                    <div className="jr-card mainHeight">
                      <div
                        data-toggle="modal"
                        data-target="#securityTechOnSiteModal"
                      >
                        <div
                          className="jr-card-header w-100 clickable"
                          role="button"
                          data-toggle="collapse"
                          data-parent="#accordion"
                          href="#collapseThree"
                          aria-expanded="true"
                          aria-controls="collapseThree"
                        >
                          <h1 className="card-heading d-inline-block">
                            Security (Tech on site){" "}
                          </h1>
                        </div>
                        <div
                          id="collapseThree"
                          className="collapse show"
                          role="tabpanel"
                        >
                          <div className="jr-card-body row">
                            <div className="col-12 col-xl-12 col-lg-12 col-sm-12 col-xs-12">
                              {this.state.techOnSiteStatus.length > 0 ? (
                                <Table striped responsive className="pl-2 ">
                                  <tbody className="w-100 d-block d-md-table d-sm-table">
                                    <tr>
                                      <th className="tableHeading">
                                        Date and Time
                                      </th>
                                      <th className="tableHeading">
                                        Technician Name
                                      </th>
                                      <th className="tableHeading">Comment</th>
                                    </tr>
                                    {this.state.techOnSiteStatus.map(
                                      (items, index) => {
                                        return (
                                          <tr key={index}>
                                            <td scope="row">
                                              {new Date(
                                                items.timestamp * 1000
                                              ).getFullYear()}
                                              -
                                              {(
                                                "0" +
                                                (new Date(
                                                  items.timestamp * 1000
                                                ).getMonth() +
                                                  1)
                                              ).substr(-2)}
                                              -
                                              {(
                                                "0" +
                                                new Date(
                                                  items.timestamp * 1000
                                                ).getDate()
                                              ).substr(-2)}
                                              ,{" "}
                                              {(
                                                "0" +
                                                new Date(
                                                  items.timestamp * 1000
                                                ).getHours()
                                              ).substr(-2)}
                                              :
                                              {(
                                                "0" +
                                                new Date(
                                                  items.timestamp * 1000
                                                ).getMinutes()
                                              ).substr(-2)}
                                              :
                                              {(
                                                "0" +
                                                new Date(
                                                  items.timestamp * 1000
                                                ).getSeconds()
                                              ).substr(-2)}{" "}
                                            </td>
                                            <td>{items.techId}</td>
                                            <td>{items.techNotes}</td>
                                          </tr>
                                        );
                                      }
                                    )}
                                  </tbody>
                                </Table>
                              ) : (
                                  <div>
                                    <div className="w-100 d-flex justify-content-center">
                                      <h2 className="pl-1">No data found</h2>
                                    </div>
                                    <canvas id="securityPitStatus" />
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>}
                {isRevDevices && this.renderGraph()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  destroyChartJsModalCharts = () => {
    if (
      this.temperatureChartModal &&
      !$.isEmptyObject(this.temperatureChartModal)
    ) {
      this.temperatureChartModal.destroy();
      this.temperatureChartModal = {};
    }
    if (
      this.waterLevelChartModal &&
      !$.isEmptyObject(this.waterLevelChartModal)
    ) {
      this.waterLevelChartModal.destroy();
      this.waterLevelChartModal = {};
    }
    // if (this.batteryChargeChartModal && !$.isEmptyObject(this.batteryChargeChartModal)) {
    //   this.batteryChargeChartModal.destroy();
    //   this.batteryChargeChartModal = {};
    // }
    if (
      this.securityPitStatusModal &&
      !$.isEmptyObject(this.securityPitStatusModal)
    ) {
      this.securityPitStatusModal.destroy();
      this.securityPitStatusModal = {};
    }
    if (
      this.securityTechOnSiteModal &&
      !$.isEmptyObject(this.securityTechOnSiteModal)
    ) {
      this.securityTechOnSiteModal.destroy();
      this.securityTechOnSiteModal = {};
    }
  };

  destroyChartJsCharts = () => {
    if (this.temperatureChart && !$.isEmptyObject(this.temperatureChart)) {
      this.temperatureChart.destroy();
      this.temperatureChart = {};
    }
    if (this.waterLevelChart && !$.isEmptyObject(this.waterLevelChart)) {
      this.waterLevelChart.destroy();
      this.waterLevelChart = {};
    }
    if (this.batteryChargeChart && !$.isEmptyObject(this.batteryChargeChart)) {
      this.batteryChargeChart.destroy();
      this.batteryChargeChart = {};
    }

    if (
      this.securityPitStatusChart &&
      !$.isEmptyObject(this.securityPitStatusChart)
    ) {
      this.securityPitStatusChart.destroy();
      this.securityPitStatusChart = {};
    }
    if (
      this.securityTechOnSiteChart &&
      !$.isEmptyObject(this.securityTechOnSiteChart)
    ) {
      this.securityTechOnSiteChart.destroy();
      this.securityTechOnSiteChart = {};
    }
  };

  disposeAllChartsAndModalsAndUnsusbcribe = () => {
    this.destroyChartJsCharts();

    this.destroyChartJsModalCharts();

    // this.disconnectMQTT();

    this.clearDeviceChartsPollingSetInterval();
  };

  constructor(props) {
    super(props);

    this.props.showLoader();

    this.UpdateTemperatureChartWithId("");
    this.UpdateWaterLevelChartWithId("");
    // this.UpdateSecurityPitStatusChartWithId();
    this.state = {
      timestamps: [],
      dateString: [],
      temperatureData: [],
      waterLevelData: [],
      powerData: [],
      batteryChargeData: [],
      pitStatusData: [],
      techStatusData: [],
      temperature_threshold_bool: false,
      waterLevel_threshold_bool: false,
      batteryCharge_threshold_bool: false,
      temperature_threshold_boolM: false,
      waterLevel_threshold_boolM: false,
      batteryCharge_threshold_boolM: false,
      showStore: true,
      showStore1: false,
      timestampsM: [],
      dateStringM: [],
      temperaturesM: [],
      waterLevelsM: [],
      batteryChargesM: [],
      pitStatusDataM: [],
      pitStatus: [],
      techStatusDataM: [],
      temperatureDropdown: false,
      latestTemperature: "",
      latestWaterLevel: "",
      latestPower: "",
      pitDepth: 45,
      chartsToShow: [
        this.temperatureChartWithId.chartJSX,
        this.waterLevelChartWithId.chartJSX,
      ],
      subscribedTopic: CONST.DEVICE_SUBSCRIBE_TOPIC.replace(
        CONST.DEVICE_ID,
        this.props.deviceId
      ),
      pitStatusTopic: CONST.DEVICE_PIT_STATUS_TOPIC.replace(
        CONST.DEVICE_ID,
        this.props.deviceId
      ),
      techStatusTopic: CONST.DEVICE_TECH_STATUS_TOPIC.replace(
        CONST.DEVICE_ID,
        this.props.deviceId
      ),
      deviceId: this.props.deviceId,
      nameOfDevicePit: "",
      currentPitStatus: "",
      currentTechOnSite: "",
      lastTechOnSite: "",
      techOnSiteStatus: [],
      lastFloodAlertInPit: null,
      pitStatusTime: [],
      latestPitStatus: "Closed",
      pitStatusTimeWithDate: [],
      pitStatusForYaxis: [],
      pitStatusModalData: [],
      pitStatusTimeModalData: [],
      pitStatusForYaxisModalData: [],
      pitStatusTimeWithDateModalData: [],
      waterLevelValueToShow: [],
      waterLevelModalValueToShow: [],
      lastUpdatedTimeWater: "",
      lastUpdatedTimeTemperature: "",
      lastUpdatedTimePower: "",
      temperatureFilter: "Latest 10 Records",
      temperaturetoggle: false,
      tempSensorType: "Sensor 1",
      tempSensorToggle: false,
      powerSensorType: "Sensor 1",
      powerSensorToggle: false,
      waterFilter: "Latest 10 Records",
      watertoggle: false,
      pitStatusFilter: "1 Day",
      pitStatustoggle: false,
      powerFilter: "Latest 10 Records",
      powerToggle: false,
      deviceLocation: {
        latitude: -24.397,
        longitude: 135.644,
        deviceID: this.props.deviceId,
        streetAddress: ''
      },
      temp: false,
      configurationValues: {},
      nodeVitals: [],
    };
  }

  plotInitialPitStatusChart(heartbeat) {
    heartbeat.securityPitStatusChart = pitStatusBubbleChart(
      heartbeat.securityPitStatusId,
      heartbeat.securityPitStatusChart,
      "bubble",
      heartbeat.state.pitStatusData,
      null
    );
    this.props.hideLoader();
  }

  plotInitialTechStatusChart(heartbeat) {
    heartbeat.securityTechOnSiteChart = pitStatusBubbleChart(
      heartbeat.securityTechOnSiteId,
      heartbeat.securityTechOnSiteChart,
      "bubble",
      heartbeat.state.techStatusData,
      null
    );
    this.props.hideLoader();
  }

  evaluateTemperatureThresholdAndReturnBooleanValue = (value, min, max) => {
    // Have to check whether min and max are null, because both these values are optional responses in API

    let satisfiesMinConstraint = false;
    let satisfiesMaxConstraint = false;

    if (min === null) {
      satisfiesMinConstraint = true;
    } else if (min !== null && value >= min) {
      satisfiesMinConstraint = true;
    }

    if (max === null) {
      satisfiesMaxConstraint = true;
    } else if (max !== null && value <= max) {
      satisfiesMaxConstraint = true;
    }

    if (satisfiesMinConstraint && satisfiesMaxConstraint) {
      return false;
    }
    return true;
  };

  evaluateWaterLevelThresholdAndReturnBooleanValue = (value, min, max) => {
    // Have to check whether min and max are null, because both these values are optional responses in API

    let satisfiesMinConstraint = false;
    let satisfiesMaxConstraint = false;

    if (min === null) {
      satisfiesMinConstraint = true;
    } else if (min !== null && value >= min) {
      satisfiesMinConstraint = true;
    }

    if (max === null) {
      satisfiesMaxConstraint = true;
    } else if (max !== null && value <= max) {
      satisfiesMaxConstraint = true;
    }

    if (satisfiesMinConstraint && satisfiesMaxConstraint) {
      return false;
    }
    return true;
  };

  evaluateThresholds = (
    data,
    minTemperatureThresholdPropertyName,
    maxTemperatureThresholdPropertyName,
    minWaterLevelThresholdPropertyName,
    maxWaterLevelThresholdPropertyName
  ) => {
    const lastTemperatureObject = data[data.length - 1].values.find((item) => {
      if (item.hasOwnProperty("temperature")) {
        return true;
      }
      return false;
    });

    let minTemperatureThreshold = null,
      maxTemperatureThreshold = null;
    if (
      lastTemperatureObject.hasOwnProperty(minTemperatureThresholdPropertyName)
    ) {
      minTemperatureThreshold =
        lastTemperatureObject[minTemperatureThresholdPropertyName];
    }

    if (
      lastTemperatureObject.hasOwnProperty(maxTemperatureThresholdPropertyName)
    ) {
      maxTemperatureThreshold =
        lastTemperatureObject[maxTemperatureThresholdPropertyName];
    }

    let latestTemperatureThresholdBool;
    const latestTemperatureValue = lastTemperatureObject.temperature;
    latestTemperatureThresholdBool = this.evaluateTemperatureThresholdAndReturnBooleanValue(
      latestTemperatureValue,
      minTemperatureThreshold,
      maxTemperatureThreshold
    );

    const lastWaterLevelObject = data[data.length - 1].values.find((item) => {
      if (item.hasOwnProperty("water")) {
        return true;
      }
      return false;
    });

    let minWaterLevelThreshold = null,
      maxWaterLevelThreshold = null;
    if (
      lastWaterLevelObject.hasOwnProperty(minWaterLevelThresholdPropertyName)
    ) {
      minWaterLevelThreshold =
        lastWaterLevelObject[minWaterLevelThresholdPropertyName];
    }

    if (
      lastWaterLevelObject.hasOwnProperty(maxWaterLevelThresholdPropertyName)
    ) {
      maxWaterLevelThreshold =
        lastWaterLevelObject[maxWaterLevelThresholdPropertyName];
    }

    let latestWaterLevelThresholdBool;
    const latestWaterLevelValue = lastWaterLevelObject.water;
    latestWaterLevelThresholdBool = this.evaluateWaterLevelThresholdAndReturnBooleanValue(
      latestWaterLevelValue,
      minWaterLevelThreshold,
      maxWaterLevelThreshold
    );

    return {
      latestTemperatureThresholdBool,
      latestWaterLevelThresholdBool,
    };
  };

  getFilteredRecord(data) {
    switch (data) {
      case "Latest 10 Records": {
        return 10;
      }
      case "1 Day": {
        return 1;
      }
      case "7 Days": {
        return 7;
      }
      case "14 Days": {
        return 14;
      }
      case "28 Days": {
        return 28;
      }
      default:
        return 10;
    }
  }

  getDateWiseData = (timestamp, toDate) => {
    const date = moment(timestamp * 1000).subtract(toDate, "days");
    return date;
  };

  findAverageOfFilteredData = (data, filter) => {
    const arrayForDays = [];
    const time = [];
    for (let i = 0; i < filter; i++) {
      const date = this.getDateWiseData(moment().format("X"), i);
      const internalArray = [];
      data &&
        data.map((item) => {
          const itemDate = moment(item.time * 1000).format("DD-MM-YYYY");
          const currentDate = date.format("DD-MM-YYYY");
          if (itemDate === currentDate) {
            internalArray.push(item.values);
          }
        });
      arrayForDays.push(internalArray);
      time.push(date.format("MMM-DD"));
    }
    return { arrayForDays: arrayForDays.reverse(), time: time.reverse() };
  };

  findAverageOfPitStatus = (data, filter) => {
    const arrayForDays = [];
    const time = [];
    for (let i = 0; i < filter; i++) {
      const date = this.getDateWiseData(moment().format("X"), i);
      const internalArray = [];
      data &&
        data.map((item) => {
          const itemDate = moment(item.timestamp * 1000).format("DD-MM-YYYY");
          const currentDate = date.format("DD-MM-YYYY");
          if (itemDate === currentDate) {
            internalArray.push(item);
          }
        });
      arrayForDays.push(internalArray);
      time.push(date.format("MMM-DD"));
    }
    return { arrayForDays: arrayForDays.reverse(), time: time.reverse() };
  };

  filterAndMapDataPitStatus = (data) => {
    const yAxisData = [];
    const dayArray = data.arrayForDays.map((item) => {
      if (item.length > 0) {
        if (item[0].security === "Open") {
          yAxisData.push(1);
        } else {
          yAxisData.push(0);
        }
        return item[0].security;
      }
      yAxisData.push(0);
      return "Closed";
    });
    return {
      dayArray,
      yAxisData,
    };
  };

  getPitStatus = () => {
    getPitStatus(this.props.deviceId, this.state.pitStatusFilter).then(
      (data) => {
        const heartbeat = this;
        const timeForPit = [],
          pitStatus = [],
          yAxisData = [],
          dateForPit = [];
        let averageData = [];
        let averageTime = [],
          dateStringToShow = [],
          pitStatusForYaxis = [];
        data.forEach((item) => {
          if (item.eventVal === "Open") {
            yAxisData.push(1);
          } else {
            yAxisData.push(0);
          }
          timeForPit.push(getTimeFromTimestamp(item.time * 1000));
          pitStatus.push(item.eventVal);
          dateForPit.push(new Date(item.time * 1000).toLocaleString());
        });
        heartbeat.setState({
          pitStatus: pitStatus.reverse(),
          pitStatusTime: timeForPit.reverse(),
          pitStatusForYaxis: yAxisData.reverse(),
          pitStatusTimeWithDate: dateForPit.reverse(),
          latestPitStatus: pitStatus[pitStatus.length - 1],
        });

        if (
          this.state.pitStatusFilter !== "Latest 10 Records" &&
          this.state.pitStatusFilter !== "1 Day"
        ) {
          const filter = this.getFilteredRecord(this.state.pitStatusFilter);
          const filteredArrays = this.findAverageOfPitStatus(data, filter);
          const dataToShow = this.filterAndMapDataPitStatus(filteredArrays);
          averageTime = filteredArrays.time;
          dateStringToShow = filteredArrays.time;
          averageData = dataToShow.dayArray;
          pitStatusForYaxis = dataToShow.yAxisData;
        } else {
          averageTime = timeForPit;
          averageData = pitStatus;
          dateStringToShow = dateForPit;
          pitStatusForYaxis = yAxisData;
        }

        heartbeat.pitStatusBubbleChart = pitStatusSteppedCharts(
          heartbeat.securityPitStatusId,
          heartbeat.pitStatusBubbleChart,
          "line",
          averageData,
          averageTime,
          dateStringToShow,
          pitStatusForYaxis,
          heartbeat.pitStatusBubbleChart &&
          !$.isEmptyObject(heartbeat.pitStatusBubbleChart),
          this.state.pitStatusFilter
        );
      }
    );
  };

  getWaterLevelData = (data) => {
    let index = 0;
    const maxThresholdWaterLevel = data.sensors[1].max;

    const heartbeat = this;
    getLastNRecordsFromAllSensors(
      this.state.waterFilter,
      this.state.deviceId,
      "water"
    )
      .then((data) => {
        const timestamps = [],
          dateString = [],
          waterLevels = [],
          waterLevelValueToShow = [];
        let averageData = [];
        let averageTime = [],
          dateStringToShow = [];
        data.forEach((item) => {
          timestamps.push(getTimeFromTimestamp(item.time * 1000));
          dateString.push(new Date(item.time * 1000).toLocaleString());

          const currentWaterLevel = item.values.find((currentItem) => {
            if (currentItem.hasOwnProperty("water")) {
              return true;
            }
            return false;
          });
          waterLevels.push(
            item && currentWaterLevel && currentWaterLevel.water
              ? currentWaterLevel.water / 10
              : 0
          );

          // batteryCharges.push(item && item.voltage ? Number.parseFloat(item.voltage) / 1000 : 0);
          if (index === 0) {
            heartbeat.lastInteractionReceived = getFormattedDate(
              item.time,
              false
            );
          }
          index++;
        });

        const depthOfPit = this.state.pitDepth / 10;
        // const findLargestValueOfWater = Math.max(...waterLevels);
        waterLevels.forEach((item) => {
          waterLevelValueToShow.push((depthOfPit - item).toFixed(2));
        });
        heartbeat.latestSD = `${
          waterLevels.length > 0 ? (depthOfPit - waterLevels[0]).toFixed(2) : 0
          }cm`;

        heartbeat.UpdateTemperatureChartWithId(heartbeat.latestT);
        heartbeat.UpdateWaterLevelChartWithId(heartbeat.latestSD);

        let thresholdBooleanWaterLevel = false;
        if (maxThresholdWaterLevel) {
          if (waterLevelValueToShow[0] > maxThresholdWaterLevel) {
            thresholdBooleanWaterLevel = true;
          }
        }
        heartbeat.setState({
          timestamps: timestamps.reverse(),
          dateString: dateString.reverse(),
          latestWaterLevel: heartbeat.latestSD,
          waterLevelData: waterLevelValueToShow.reverse(),
          // waterLevelValueToShow: waterLevelValueToShow.reverse(),
          lastUpdatedTimeWater: data.length > 0 && data[0].time,
        });

        if (
          this.state.waterFilter !== "Latest 10 Records" &&
          this.state.waterFilter !== "1 Day"
        ) {
          const filter = this.getFilteredRecord(this.state.waterFilter);
          const filteredArrays = this.findAverageOfFilteredData(data, filter);
          averageTime = filteredArrays.time;
          dateStringToShow = filteredArrays.time;
          averageData = filteredArrays.arrayForDays.map((item) => {
            if (item.length > 0) {
              const sum = item.reduce((a, b) => {
                const water = b[0] && b[0].water ? b[0].water : 0;
                return a + water / 10;
              }, 0);
              const average = sum / item.length;
              if (Number.isNaN(average)) {
                return depthOfPit;
              }
              return (depthOfPit - average).toFixed(2);
            }
            return 0;
          });
        } else {
          averageTime = timestamps;
          averageData = waterLevelValueToShow;
          dateStringToShow = dateString;
        }
        heartbeat.waterLevelChart = realtimeChart(
          heartbeat.waterLevelId,
          heartbeat.waterLevelChart,
          "line",
          averageTime,
          averageData,
          thresholdBooleanWaterLevel,
          20,
          heartbeat.waterLevelChart &&
          !$.isEmptyObject(heartbeat.waterLevelChart),
          dateStringToShow,
          averageData,
          depthOfPit,
          this.state.waterFilter
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getAllConfiguration = () => {
    getAllConfiguration(this.props.deviceId)
      .then((item) => {
        this.setState({
          configurationValues: item,
        });
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  };

  getPowerData = () => {
    let index = 0;
    // const minThresholdTemperature = data.sensors[0].min;
    // const maxThresholdTemperature = data.sensors[0].max;

    const heartbeat = this;
    const powerType = powerTypeSensor.filter((items) => {
      return items.item === this.state.powerSensorType;
    });
    const type = powerType[0].type;
    getLastNRecordsFromAllSensors(
      this.state.powerFilter,
      this.state.deviceId,
      type
    )
      .then((data) => {
        const timestamps = [],
          currentValues = [],
          dateString = [];
        let averageData = [];
        let averageTime = [];
        let dateStringToShow = [];
        data.length > 0 &&
          data.forEach((item) => {
            timestamps.push(getTimeFromTimestamp(item.time * 1000));
            dateString.push(new Date(item.time * 1000).toLocaleString());

            const currentPower = item.values.find((currentItem) => {
              if (currentItem.hasOwnProperty(type)) {
                return true;
              }
              return false;
            });
            currentValues.push(
              item && currentPower && currentPower[type]
                ? currentPower[type]
                : 0
            );

            if (index === 0) {
              heartbeat.lastInteractionReceived = getFormattedDate(
                item.time,
                false
              );
            }
            index++;
          });

        if (
          this.state.powerFilter !== "Latest 10 Records" &&
          this.state.powerFilter !== "1 Day"
        ) {
          const filter = this.getFilteredRecord(this.state.powerFilter);
          const filteredArrays = this.findAverageOfFilteredData(data, filter);
          averageTime = filteredArrays.time;
          dateStringToShow = filteredArrays.time;
          averageData = filteredArrays.arrayForDays.map((item) => {
            if (item.length > 0) {
              const sum = item.reduce((a, b) => {
                const powerData = b[0] && b[0][type] ? b[0][type] : 0;
                return a + powerData;
              }, 0);
              const average = sum / item.length;
              if (Number.isNaN(average)) {
                return 0;
              }
              return average.toFixed(2);
            }
            return 0;
          });
        } else {
          averageTime = timestamps;
          dateStringToShow = dateString;
          averageData = currentValues;
        }

        heartbeat.latestP = `${
          currentValues.length > 0 ? currentValues[0] : 0
          } amp`;

        // heartbeat.UpdateTemperatureChartWithId(heartbeat.latestT);

        const thresholdsBoolTemperature = false;
        // if (maxThresholdTemperature && minThresholdTemperature) {
        //   if (
        //     currentValues[0] > maxThresholdTemperature ||
        //     currentValues[0] < minThresholdTemperature
        //   ) {
        //     thresholdsBoolTemperature = true;
        //   }
        // }
        heartbeat.setState({
          timestamps: timestamps.reverse(),
          dateString: dateString.reverse(),
          latestPower: heartbeat.latestP,
          powerData: currentValues.reverse(),
          lastUpdatedTimePower: data.length > 0 && data[0].time,
        });

        heartbeat.powerChart = realtimeChart(
          heartbeat.powerId,
          heartbeat.powerChart,
          "line",
          averageTime,
          averageData,
          thresholdsBoolTemperature,
          null,
          heartbeat.powerChart && !$.isEmptyObject(heartbeat.powerChart),
          dateStringToShow,
          null,
          null,
          this.state.powerFilter
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getTemperatureData = (data) => {
    let index = 0;
    const minThresholdTemperature = data.sensors[0].min;
    const maxThresholdTemperature = data.sensors[0].max;
    const heartbeat = this;
    const tempType = tempTypeSensor.filter((items) => {
      return items.item === this.state.tempSensorType;
    });
    const type = tempType[0].type;
    // if (type === tempTypeSensor[0].type) {
    //   heartbeat.temperatureChart = groupLineChart(
    //     heartbeat.temperatureId,
    //     heartbeat.temperatureChart,
    //     heartbeat.temperatureChart &&
    //     !$.isEmptyObject(heartbeat.temperatureChart),
    //   );
    // } else {
    getLastNRecordsFromAllSensors(
      this.state.temperatureFilter,
      this.state.deviceId,
      type
    )
      .then((data) => {
        const timestamps = [],
          temperatures = [],
          dateString = [];
        let averageData = [];
        let averageTime = [];
        let dateStringToShow = [];
        data.length > 0 &&
          data.forEach((item) => {
            timestamps.push(getTimeFromTimestamp(item.time * 1000));
            dateString.push(new Date(item.time * 1000).toLocaleString());

            const currentTemperature = item.values.find((currentItem) => {
              if (currentItem.hasOwnProperty(type)) {
                return true;
              }
              return false;
            });
            temperatures.push(
              item && currentTemperature && currentTemperature[type]
                ? currentTemperature[type]
                : 0
            );

            if (index === 0) {
              heartbeat.lastInteractionReceived = getFormattedDate(
                item.time,
                false
              );
            }
            index++;
          });

        if (
          this.state.temperatureFilter !== "Latest 10 Records" &&
          this.state.temperatureFilter !== "1 Day"
        ) {
          const filter = this.getFilteredRecord(this.state.temperatureFilter);
          const filteredArrays = this.findAverageOfFilteredData(data, filter);
          averageTime = filteredArrays.time;
          dateStringToShow = filteredArrays.time;
          averageData = filteredArrays.arrayForDays.map((item) => {
            if (item.length > 0) {
              const sum = item.reduce((a, b) => {
                const temperatureData = b[0] && b[0][type] ? b[0][type] : 0;
                return a + temperatureData;
              }, 0);
              const average = sum / item.length;
              if (Number.isNaN(average)) {
                return 0;
              }
              return average.toFixed(2);
            }
            return 0;
          });
        } else {
          averageTime = timestamps;
          dateStringToShow = dateString;
          averageData = temperatures;
        }

        heartbeat.latestT = `${
          temperatures.length > 0 ? temperatures[0] : 0
          }º`;

        heartbeat.UpdateTemperatureChartWithId(heartbeat.latestT);

        let thresholdsBoolTemperature = false;
        if (maxThresholdTemperature && minThresholdTemperature) {
          if (
            temperatures[0] > maxThresholdTemperature ||
            temperatures[0] < minThresholdTemperature
          ) {
            thresholdsBoolTemperature = true;
          }
        }
        heartbeat.setState({
          timestamps: timestamps.reverse(),
          dateString: dateString.reverse(),
          latestTemperature: heartbeat.latestT,
          temperatureData: temperatures.reverse(),
          lastUpdatedTimeTemperature: data.length > 0 && data[0].time,
        });
        heartbeat.temperatureChart = realtimeChart(
          heartbeat.temperatureId,
          heartbeat.temperatureChart,
          "line",
          averageTime,
          averageData,
          thresholdsBoolTemperature,
          null,
          heartbeat.temperatureChart &&
          !$.isEmptyObject(heartbeat.temperatureChart),
          dateStringToShow,
          null,
          null,
          this.state.temperatureFilter
        );
      })
      .catch((err) => {
        console.log(err);
      });
    // }
  };

  querySensorAPIAndPlotDeviceCharts = () => {
    this.getPowerData();
    getPitWarningLevel(this.props.deviceId)
      .then((data) => {
        getLocation(this.props.deviceId).then((item) => {
          this.setState({
            deviceLocation: {
              latitude: item.lat,
              longitude: item.lon,
              deviceID: this.props.deviceId,
              streetAddress: item.streetAddress,
            },
          });
        });
        this.getTemperatureData(data);
        this.getWaterLevelData(data);
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  };

  getTimeStampsInSeconds = (minsBack) => {
    const timeStampOfNowInSeconds =
      Math.trunc(+new Date() / 1000) - 10 * 60 * 60;
    const pollingFromTimeStampInSeconds =
      timeStampOfNowInSeconds - minsBack * 60;
    const pollingToTimeStampInSeconds = timeStampOfNowInSeconds;

    return {
      pollingFromTimeStampInSeconds,
      pollingToTimeStampInSeconds,
    };
  };

  fetchTechOnSiteData = () => {
    requestTechOnSiteData(this.props.deviceId, "Checkin")
      .then((data) => {
        this.setState({
          techOnSiteStatus: data,
        });
      })
      .catch((error) => {
        this.setState({
          techOnSiteStatus: [],
        });
      });
  };

  getChartData = () => {
    getPitDepth(this.props.deviceId)
      .then((item) => {
        this.setState({
          pitDepth: item.pitDepth,
        });
      })
      .catch((error) => {
        console.log("error: ", error);
      });
    this.getPitStatus();
    this.querySensorAPIAndPlotDeviceCharts();
    this.fetchTechOnSiteData();
  };

  getLastUpdatedTime = () => {
    let nodeVitalsUpdatedTime = this.state.nodeVitals.length > 0 && this.state.nodeVitals[0] && this.state.nodeVitals[0].time;
    let maxTime = Math.max(this.state.lastUpdatedTimeWater,
      this.state.lastUpdatedTimeTemperature,
      this.state.lastUpdatedTimePower,
      nodeVitalsUpdatedTime);
    if (
      this.state.lastUpdatedTimeWater ||
      this.state.lastUpdatedTimeTemperature ||
      this.state.lastUpdatedTimePower ||
      nodeVitalsUpdatedTime
    ) {
      const date = maxTime;
      const updatedTime = `${new Date(date * 1000).getFullYear()}-${(
        "0" +
        (new Date(date * 1000).getMonth() + 1)
      ).substr(-2)}-${("0" + new Date(date * 1000).getDate()).substr(-2)}, ${(
        "0" + new Date(date * 1000).getHours()
      ).substr(-2)}:${("0" + new Date(date * 1000).getMinutes()).substr(-2)}:${(
        "0" + new Date(date * 1000).getSeconds()
      ).substr(-2)}`;
      return updatedTime;
    }
  };

  getNextUpdatedTime = () => {
    let nodeVitalsUpdatedTime = this.state.nodeVitals.length > 0 && this.state.nodeVitals[0] && this.state.nodeVitals[0].time;
    let maxTime = Math.max(this.state.lastUpdatedTimeWater,
      this.state.lastUpdatedTimeTemperature,
      this.state.lastUpdatedTimePower,
      nodeVitalsUpdatedTime);
    const transmitInterval =
      Object.keys(this.state.configurationValues).length > 0
        ? this.state.configurationValues.network &&
        this.state.configurationValues.network.reported
        : 0;
    const currentDate = new Date();
    const nextUpdatedTime =
      (new Date((maxTime + transmitInterval) * 1000) - currentDate) /
      1000;
    // let hours = Math.floor(nextUpdatedTime / 3600).toString().replace('-', '');
    // let minutes = (Math.floor(nextUpdatedTime / 60) - (hours * 60)).toString().replace('-', '');
    let d = Number(nextUpdatedTime.toString().replace('-', ''));
    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    let s = Math.floor(d % 3600 % 60);

    let hDisplay = h > 0 ? h + (h == 1 ? " hour" : " hours") : "";
    let mDisplay = m > 0 ? m + (m == 1 ? " minute" : " minutes") : "";
    // let sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
    if (transmitInterval) {
      if (nextUpdatedTime >= 0) {
        return `Next update in ${hDisplay} ${mDisplay}`;
      }
      else {
        return `Update delayed by ${hDisplay} ${mDisplay}`;
      }
    }
  }

  getUpdatedTimeAgo = () => {
    let nodeVitalsUpdatedTime = this.state.nodeVitals.length > 0 && this.state.nodeVitals[0] && this.state.nodeVitals[0].time;
    if (
      this.state.lastUpdatedTimeWater ||
      this.state.lastUpdatedTimeTemperature ||
      this.state.lastUpdatedTimePower ||
      nodeVitalsUpdatedTime
    ) {
      return Math.max(this.state.lastUpdatedTimeWater,
        this.state.lastUpdatedTimeTemperature,
        this.state.lastUpdatedTimePower,
        nodeVitalsUpdatedTime);
    }
  };

  getdeviceOnline = () => {
    let nodeVitalsUpdatedTime = this.state.nodeVitals.length > 0 && this.state.nodeVitals[0] && this.state.nodeVitals[0].time;
    const transmitInterval =
      Object.keys(this.state.configurationValues).length > 0
        ? this.state.configurationValues.network &&
        this.state.configurationValues.network.reported
        : 0;
    const currentDate = new Date();
    const lastUpdatedTime = Math.max(this.state.lastUpdatedTimeWater,
      this.state.lastUpdatedTimeTemperature,
      this.state.lastUpdatedTimePower,
      nodeVitalsUpdatedTime);
    const isActive =
      (currentDate < new Date((lastUpdatedTime + transmitInterval) * 1000)) /
      1000;
    if (isActive) {
      return <img
        className="battery-charge-img d-inline-block mx-2 pl-0"
        src="../../../../assets/images/online.png"
        alt="Online"
        style={{
          borderRadius: 15,
        }}
      />;
    } else if (lastUpdatedTime === null) {
      return <img
        className="battery-charge-img d-inline-block mx-2 pl-0"
        src="../../../../assets/images/offline.png"
        alt="Offline"
        style={{
          borderRadius: 15,
        }}
      />;
    }
    return <img
      className="battery-charge-img d-inline-block mx-2 pl-0"
      src="../../../../assets/images/redIc.png"
      alt="Offline"
      style={{
        borderRadius: 15,
      }}
    />;
  };

  showBatteryLevel = (batteryVoltage) => {
    if (batteryVoltage > 6.8) {
      return <i
        className="fa fa-battery-full text-green mx-2 signalBatteryIcon"
        aria-hidden="true"
      />
    } else if (batteryVoltage >= 6.6 && batteryVoltage <= 6.89) {
      return <i
        className="fa fa-battery-three-quarters text-yellow mx-2 signalBatteryIcon"
        aria-hidden="true"
      />

    } else if (batteryVoltage >= 6.0 && batteryVoltage <= 6.59) {
      return <i
        className="fa fa-battery-half display-1 text-orange mx-2 signalBatteryIcon"
        aria-hidden="true"
      />

    } else {
      return <i
        className="fa fa-battery-quarter text-red mx-2 signalBatteryIcon"
        aria-hidden="true"
      />
    }
  }

  showSignalLevel = (signalStrength) => {
    if (signalStrength > 25) {
      return <img
        className="battery-charge-img d-inline-block mx-2 pl-0"
        src="../../../../assets/images/signal4.png"
        alt="signal4"
      />;
    } else if (signalStrength >= 14 && signalStrength <= 25) {
      return <img
        className="battery-charge-img d-inline-block mx-2 pl-0"
        src="../../../../assets/images/signal3.png"
        alt="signal3"
      />;

    } else if (signalStrength >= 8 && signalStrength <= 13) {
      return <img
        className="battery-charge-img d-inline-block mx-2 pl-0"
        src="../../../../assets/images/signal2.png"
        alt="signal2"
      />;

    } else {
      return <img
        className="battery-charge-img d-inline-block mx-2 pl-0"
        src="../../../../assets/images/signal1.png"
        alt="signal1"
      />;
    }
  }

  pollForDeviceChartData = () => {
    this.getChartData();
    this.getAllConfiguration();
    getIndividualNodeVitals(this.props.deviceId)
      .then((data) => {
        this.setState({
          nodeVitals: data
        })
      })
      .catch((error) => {
        console.log('error: ', error);
      })
    this.deviceChartsPollingSetInterval = setInterval(() => {
      this.getChartData();
      this.getAllConfiguration();
    }, CONST.UPDATE_INTERVAL);
  };

  clearDeviceChartsPollingSetInterval = () => {
    clearInterval(this.deviceChartsPollingSetInterval);
  };

  componentDidMount() {
    this.pollForDeviceChartData();
    this.props.hideLoader();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.deviceId !== this.state.deviceId) {
      this.UpdateTemperatureChartWithId("");
      this.UpdateWaterLevelChartWithId("");
      this.disposeAllChartsAndModalsAndUnsusbcribe();
      this.setState(
        {
          deviceId: nextProps.deviceId,
        },
        () => {
          this.pollForDeviceChartData();
        }
      );
    } else if (nextProps.payload !== this.props.payload) {
      console.log("Next props");
    }
  }

  componentWillMount() {
    const windowWidth = $(window).width();
    if (windowWidth <= 567) {
      this.setState({
        isLarge: false,
      });
    } else {
      this.setState({
        isLarge: true,
      });
    }
  }

  componentWillUnmount() {
    this.disposeAllChartsAndModalsAndUnsusbcribe();
  }
}

const mapStateToProps = ({ symbioticReducer }) => {
  return {
    deviceId: symbioticReducer.deviceId,
    thresholds: symbioticReducer.thresholds,
    layoutHeartBeat: symbioticReducer.layoutHeartbeat,
    isMARight: symbioticReducer.isMARight,
    payload: symbioticReducer.payload,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // Dispatch action to show loader
    showLoader: () => {
      dispatch({ type: "SHOW_OVERALL_APP_LOADER" });
    },
    // Dispatch action to hide loader
    hideLoader: () => {
      dispatch({
        type: "HIDE_OVERALL_APP_LOADER",
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./app/routes/heartbeat/index.js